import React from "react";
import { Project } from "core/models";
import { cx } from "utils/join-classnames";
import ProjectLogo from "ui/components/atoms/ProjectLogo";
import styles from "./ProjectCard.module.scss";

interface Props {
    project: Project;
    active?: boolean;
    onClick(project: Project): void;
}

const ProjectCard: React.FC<Props> = ({ project, onClick, active }: Props) => (
        <div
            role="presentation"
            className={cx(
                styles.project,
                active ? styles["project--active"] : null,
            )}
            onClick={() => onClick(project)}
        >
            <ProjectLogo
                projectId={project.id}
                className={styles.project__img}
            />
            <div
                className={cx(
                    styles.project__title,
                    active ? styles.project_title_active : null,
                )}
            >
                {project.name}
            </div>
        </div>
    );

export default ProjectCard;
